import {
  SegmentClassificationModel,
  SegmentModel,
} from "../models/SegmentClassificationModel";
import API, { client } from "./API";

const SegmentClassificationService = {
  async getAllSegmentClassifications() {
    const response = await API().get("SegmentClassification", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularSegmentClassification(sc_id: number) {
    const response = await API().get("SegmentClassification");
    return response.data.filter(
      (cur_sc: SegmentClassificationModel) => cur_sc.segmentclassid === sc_id
    )[0];
  },
  async createSegmentClassification(data: SegmentModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `SegmentClassification/${id}` : "SegmentClassification",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default SegmentClassificationService;
